import { bool, number, shape, string } from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { imageUrl } from 'util/images';
import Image from 'components/Image';
import LazyLoad from 'components/LazyLoad';
import NoscriptImageFallback from 'components/NoscriptImageFallback';

function SlideGalleryImage(props) {
  const { index, left, isActiveSlide, image } = props;

  return (
    <li
      key={image.url}
      className={classnames(
        'SlideGallery__slide-image-item',
        isActiveSlide ? 'show' : 'hidden'
      )}
      data-gtm-gallery-type="slide-gallery"
      data-gtm-gallery-format="standard"
      data-gtm-slide-type="content"
      data-gtm-slide-idx={index + 1}
    >
      <LazyLoad once>
        <div
          className="SlideGallery__slideImageWrapper"
          style={{ left: `${left}px`, position: 'relative' }}
        >
          <Image {...image} />
        </div>
      </LazyLoad>
      <NoscriptImageFallback url={imageUrl(image.url)} alt={image.alt || ''} />
    </li>
  );
}

SlideGalleryImage.propTypes = {
  left: number.isRequired,
  index: number.isRequired,
  image: shape({
    url: string,
    width: number,
    height: number,
    format: string,
    alt: string,
    caption: string,
    isPinnable: bool
  }).isRequired,
  isActiveSlide: bool.isRequired
};

SlideGalleryImage.defaultProps = {};

export default SlideGalleryImage;
